import IpAddressWrapper from './IpAddressWrapper';

export default IpAddressWrapper;
